function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M37.798 8.628a3.221 3.221 0 014.59-.313 3.334 3.334 0 01.356 4.6l-.048.057-22.745 26.4a3.221 3.221 0 01-4.699.212l-.051-.052-9.75-9.9a3.334 3.334 0 01.003-4.667 3.22 3.22 0 014.547-.05l.053.053 7.29 7.401L37.797 8.63z",
  fill: "#fff"
});

var SvgCheckWhite = function SvgCheckWhite(props) {
  return React.createElement("svg", _extends({
    width: 48,
    height: 48
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0OCIgaGVpZ2h0PSI0OCIgdmlld0JveD0iMCAwIDQ4IDQ4Ij4KICAgIDxwYXRoIHN0eWxlPSJmaWxsOiNmZmZmZmYiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTM3Ljc5OCA4LjYyOGMxLjE4Mi0xLjM3MiAzLjIzNy0xLjUxMiA0LjU5LS4zMTMgMS4zMzQgMS4xODMgMS40ODcgMy4yMjcuMzU2IDQuNmwtLjA0OC4wNTctMjIuNzQ1IDI2LjRjLTEuMjIzIDEuNDItMy4zNjQgMS41MS00LjY5OS4yMTJsLS4wNTEtLjA1Mi05Ljc1LTkuOWMtMS4yNy0xLjI5LTEuMjY4LTMuMzc5LjAwMy00LjY2NyAxLjI1My0xLjI3IDMuMjc0LTEuMjg2IDQuNTQ3LS4wNWwuMDUzLjA1MyA3LjI5IDcuNDAxTDM3Ljc5NyA4LjYzeiIvPgo8L3N2Zz4K";
export { SvgCheckWhite as ReactComponent };